export default __webpack_public_path__ + "static/media/preview-pure-media.4a1d07ce.JPG";